<app-modal
  #modal
  [modalConfig]="{
    titleText: 'ProForm Submissions',
    options: { size: 'xl' },
    headerClass: ['modal-header', 'bg-primary', 'text-white', 'border-0'],
    bodyClass: ['submission-body', 'p-0'],
    customFooter: true
  }"
  (isClosing)="resetModal()"
  (isDismissing)="resetModal()">
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="modal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>

  <div class="w-100" style="background-color: #fff; min-height: 500px">
    <div *ngIf="display === modalDisplays.LIST">
      <div class="submission-header fs-28">
        All Submissions for <span>{{ formTitle }}</span>
      </div>
      <ng-container *ngIf="!submissionsLoading; else loading">
        <div class="submission-list">
          <table class="table" *ngIf="submissionData">
            <thead>
              <tr>
                <th class="view">View</th>
                <th class="date">Submission Date</th>
                <th>User</th>
                <th *ngIf="isQuiz" class="text-center">Grade</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="align-middle"
                style="height: 51px"
                *ngFor="let submission of submissionData; index as i">
                <td class="w-auto">
                  <button
                    ngbTooltip="Preview form submission"
                    (click)="showSubmissionDetails(submission)"
                    class="btn btn-link color-tertiary p-0 mx-2">
                    <i class="bi bi-eye"></i>
                  </button>
                </td>
                <td>
                  {{ submission.created_at | formatDate }}
                </td>
                <td>
                  {{ submission.user?.profile | fullNameFromProfile }}
                </td>
                <td
                  *ngIf="isQuiz"
                  class="text-center"
                  [ngClass]="
                    submission.pass_or_fail === 'pass'
                      ? 'text-success'
                      : 'text-danger'
                  ">
                  {{ submission.grade }}
                  <div class="fw-800 fs-12">
                    {{ submission.pass_or_fail | titlecase }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <section>
            <div class="d-flex justify-content-center">
              <ngb-pagination
                *ngIf="pagination && pagination.pageCount > 1"
                [(page)]="pagination.currentPage"
                [pageSize]="10"
                [collectionSize]="pagination.totalCount"
                [maxSize]="5"
                (pageChange)="pageChange($event)"></ngb-pagination>
            </div>
          </section>
        </div>
      </ng-container>
    </div>

    <div *ngIf="display === modalDisplays.SUBMISSION && currentSubmission">
      <div class="submission-toolbar">
        <div class="button-bar">
          <button
            ngbTooltip="View all submissions"
            placement="bottom"
            class="btn index-button p-1"
            (click)="viewAllSubmissions()">
            <i class="bi bi-card-list"></i>
          </button>

          <button
            *ngIf="submissionData.length > 1"
            ngbTooltip="Previous submission"
            placement="bottom"
            class="btn sub-btn-arrow p-1"
            (click)="goToSubmission('previous')"
            [disabled]="currentSubmissionIdx === 0">
            <i class="bi bi-chevron-left"></i>
          </button>

          <button
            *ngIf="submissionData.length > 1"
            ngbTooltip="Next submission"
            placement="bottom"
            class="btn sub-btn-arrow p-1"
            (click)="goToSubmission('next')"
            [disabled]="currentSubmissionIdx === pagination.totalCount - 1">
            <i class="bi bi-chevron-right"></i>
          </button>
          <div class="page-numbers">
            {{ currentSubmissionIdx + 1 }} of {{ pagination.totalCount }}
          </div>
        </div>
        <div class="info-content">
          <div
            *ngIf="currentSubmission && currentSubmission?.created_at"
            class="sub-text">
            <strong class="me-2">Date:</strong>
            {{ currentSubmission.created_at | formatDate }}
          </div>
          <div class="sub-text">
            <strong class="me-2">User:</strong>
            {{ currentSubmission.user?.profile | fullNameFromProfile }}
          </div>
          <div
            *ngIf="currentSubmission.context_table === 'pd_session'"
            class="sub-text">
            <strong class="me-2">Context: </strong>
            <button
              (click)="openSession(currentSubmission)"
              class="btn btn-link">
              Learning & Events Session
            </button>
          </div>
        </div>
      </div>
      <div class="submission-content">
        <div class="form-wrapper-shadow">
          <app-proforms-form
            [formId]="formId"
            [submissionId]="currentSubmission.id"
            [viewState]="viewStates.GRADED" />
        </div>
      </div>
    </div>

    <ng-template #loading>
      <div class="w-100" style="background-color: #fff; height: 400px">
        <app-loader></app-loader>
      </div>
    </ng-template>
  </div>
  <div footerContent>
    <button
      type="button"
      class="btn btn-md btn-primary"
      (click)="modal.close(); resetModal()">
      Done
    </button>
  </div>
</app-modal>
